<template>
  <div>
    <v-dialog scrollable max-width="1200px" v-model="model" persistent>
      <material-card
        :title="$t('components.new_providers.provider_office_dialog.title_{0}', [email])"
        :color="$vuetify.theme.themes.light.secondary"
        icon="folder_shared"
        v-if="item"
      >
        <v-card-text style="margin-top:20px">
          <v-container fluid>
            <v-row justify-center>
              <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                {{
                  $t(
                    "components.new_providers.provider_office_dialog.office_number"
                  )
                }}
                <br />
                <span class="minfo">
                  {{ item.Office.OfficeNumber }}
                </span>
              </div>
              <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                {{ $t("globals.address") }}
                <br />
                <span class="minfo">
                  {{ formatAddress(item.Office) }}
                </span>
              </div>
              <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                {{ $t("headers.members_management.Email") }}
                <br />
                <span class="minfo">
                  {{ item.Email }}
                </span>
              </div>
              <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                {{ $t("components.plancreationwizard.account_number") }}
                <br />
                <span class="minfo">
                  {{ item.AccountNumber }}
                </span>
              </div>
              <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                {{ $t("components.plancreationwizard.transit_number") }}
                <br />
                <span class="minfo">
                  {{ item.TransitNumber }}
                </span>
              </div>
              <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                {{ $t("components.plancreationwizard.institution_number") }}
                <br />
                <span class="minfo">
                  {{ item.InstitutionNumber }}
                </span>
              </div>
            </v-row>
            <v-btn color="primary" @click="openBillingInfo" v-if="isDental">
              {{
                $t(
                  "components.new_providers.providers_table.update_info"
                )
              }}
            </v-btn>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="$emit('close')">
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <billing-info-dialog
      :billingInfoItem="billingInfoItem"
      :officeId="item?item.Office.Id:null"
      :providerId="providerId"
      :model="billingInfoDialog"
      @close="billingInfoDialog = false"
      @saved="$emit('saved-billing-info', $event);billingInfoDialog=false;"
    />
  </div>
</template>

<script>
import { translate } from "@/trans";
import { mapGetters, mapActions } from "vuex";
import BillingInfoDialog from "./BillingInfoDialog.vue";
export default {
  props: ["model", "item", "isDental", "email", "providerId"],
  components: {
    BillingInfoDialog,
  },
  data() {
    return {
      billingInfoItem: null,
      billingInfoDialog: false,
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
  },
  methods: {
    formatAddress(item) {
      console.log(item);
      var res = "";
      if (item) {
        if (item.Address1) {
          res += item.Address1 + "\n";
          if (item.Address2) {
            res += item.Address2 + "\n";
            if (item.Address3) {
              res += item.Address3 + "\n";
            }
          }
        }
        if (item.City) {
          if (res.length > 0) res += "\n";
          res += item.City;
        }
        if (item.Province) {
          if (res.length > 0) res += ", ";
          res += item.Province.Code;
        }

        if (item.PostalCode) res += " " + item.PostalCode;
        if (item.Country)
          res += "\n " + translate(item.Country, this.language.language);
      }
      return res;
    },
    openBillingInfo() {
      this.billingInfoItem = {
        AccountNumber: this.item.AccountNumber,
        TransitNumber: this.item.TransitNumber,
        InstitutionNumber: this.item.InstitutionNumber,
        Email: this.email,
      };
      this.billingInfoDialog = true;
    },
  },
};
</script>

<style scoped>
.minfo {
  font-weight: bold;
  color: #222;
}
</style>
